export default __webpack_public_path__ + "static/media/video-blue.6621873f.svg";